/* template */
<template minapp="mpx" xlang="wxml"><div class="mpx-root-view"><controllable-drawer-bottom title="请登录12306" :show="(show)" :headerStyle="(headerStyle)" :containerStyle="({zIndex: 999})" :iconStyle="(iconStyle)" @close="closeLogin12306Drawer"><div class="login-drawer-container"><div class="login-content-container"><div class="es-login-form"><div class="quick-login-account" v-if="(loginPageStatus.quickLogin)">{{ accountWithStar }}</div><template v-if="(loginPageStatus.commonLogin || loginPageStatus.changeUser)"><div class="es-login-input"><mpx-input type="text" ref="name" placeholder="12306用户名/邮箱/手机号" :value="inputdata" mpxModelEvent="input" @mpxModel='__model("inputdata", $event, ["value"], undefined)' class="inputStyle"/></div><div class="es-login-input"><mpx-input :type="(passwordType)" ref="password" :style="[(fontSizeAdapt)] | transRpxStyle" placeholder="请输入12306密码" :value="passWordData" mpxModelEvent="input" @mpxModel='__model("passWordData", $event, ["value"], undefined)' class="inputStyle"/><mpx-view @tap="eyehandle" class="icon-eye-close"><template v-if="(!eyeState)"><mpx-image src="https://pt-starimg.didistatic.com/static/starimg/img/LpvhCITOpN1642147541419.png" class="es-eye"></mpx-image></template><template v-else><mpx-image src="https://pt-starimg.didistatic.com/static/starimg/img/FLGAZitaXS1642147590072.png" class="es-eye"></mpx-image></template></mpx-view></div><div class="es-login-input" v-if="(accountChannel !== 'app')"><mpx-input type="text" ref="digit" placeholder="请输入登录账号绑定的证件号后四位" :value="digitdata" mpxModelEvent="input" @mpxModel='__model("digitdata", $event, ["value"], undefined)' class="inputStyle"/></div><div class="form-block"></div></template><div class="es-rm-agree-box" v-if="(!loginPageStatus.commonLogin)"><div class="es-login-agree-left"><div class="es-rm-agreement"><es-checkbox-group :value="checkboxValue" mpxModelEvent="input" @mpxModel='__model("checkboxValue", $event, ["value"], undefined)' direction="row"><es-checkbox label-position="right" name="1" shap="square" :iconSize="(16)" :icon-style="({borderRadius: '6px'})" :useIconSlot="(true)" color="#338FFF"><mpx-image mode="aspectFit" slot="icon" src="https://ut-static.udache.com/webx/sfc/f2m654Y-v5zvwcBCQw1aO.png" class="es-zdy-icon" v-if="(statusCheckout)"></mpx-image><span class="es-rm-checkbox">我阅读并同意以下协议<mpx-view @tap="goto" class="es-rm-navigator highlight es-line">《个人信息处理授权协议》</mpx-view></span></es-checkbox></es-checkbox-group></div></div><mpx-view @tap="goNext" class="es-rm-navigator" v-if="(!loginPageStatus.quickLogin)">忘记密码</mpx-view></div><mpx-view @tap="quickLoginHandle" class="buttonStyle login" v-if="(loginPageStatus.quickLogin)">一键登录12306</mpx-view><mpx-view @tap="submit" class="buttonStyle login" v-if="(loginPageStatus.commonLogin || loginPageStatus.changeUser)">登录12306</mpx-view><mpx-view @tap="goRegister" class="register" v-if="(!loginPageStatus.quickLogin)">没有账号？30s极速注册</mpx-view><mpx-view @tap="switchUserStatus" class="change-user" v-else>切换账号</mpx-view></div></div><div class="exemption-content-container" v-if="(!isScramble)"><div class="exemption-content-container-left"><div class="exemption-content-container-title">不登录，便携购票<div class="service-fee" v-if="(serviceFee)">{{serviceFee}}</div></div><div class="rights-container" v-if="(rightsTips.length)"><mpx-view @click="openRightsDescDrawer" class="exemption-content-container-tips"><div v-for="(item, index) in (rightsTips)" class="tip"><spring-icon w="16" h="15" color="#999" name="marketing-check-mark" :externClass='["marketing-check-mark"].join(" ")'/>{{ item }}</div></mpx-view><div class="icon"><spring-icon w="16" h="15" color="#666" name="right-thin-arrow" :externClass='["marketing-check-mark"].join(" ")'/></div></div></div><div class="exemption-content-container-right"><div class="offline-coupon" v-if="(offlineCoupon)">{{offlineCoupon}}</div><mpx-view @tap="submitOrder" class="buy-btn">购票</mpx-view></div></div></div></controllable-drawer-bottom><es-riskmanagement loginType="login" @closepopup="closeLogin12306Drawer"></es-riskmanagement></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"mf9ffda7a"}'>
  /deep/ .es-dialog__confirm
    color #338FFF !important
  .protocol
    font-size 14px
    display inline
    line-height 17px
    font-weight 400
    font-family PingFangSC-Regular
    &.text
      color #666
    &.url
      color #338FFF
  .login-drawer-container
    background #F2F6F9
    display flex
    flex-direction column
    padding 40px 20px
    padding-top 0
    .exemption-content-container
      height 72px
      width 100%
      padding 0 16px
      display flex
      justify-content space-between
      align-items center
      box-sizing border-box
      margin-top 8px
      background #fff
      border-radius 8px
      &-left
        min-width 0
        flex 1
        display flex
        flex-direction column
        justify-content center
      .rights-container
        display flex
        .icon
          position relative
          top 5px
          left 4px
      &-title
        display flex
        align-items center
        font-size 16px
        line-height 16px
        font-family PingFangSC-Semibold
        font-weight 600
        color #333
        .question-mark
          margin-left 4px
        .service-fee
          font-size: 11px
          color: #999999
          margin-left: 4px
          position: relative
          top: 2px
      &-tips
        display flex
        font-family PingFangSC-Regular
        font-weight 400
        font-size 11px
        line-height 12px
        padding-top 12px
        color #666
        overflow auto hidden
        flex-wrap nowrap
        .tip
          flex-shrink 0
          display flex
          align-items center
          flex-wrap nowrap
          &:not(:last-child)
            margin-right 8px
          .marketing-check-mark
            margin-right 3px
      &-right
        display flex
        flex-direction column
        align-items center
        margin-left 32px
        .offline-coupon
          font-family PingFangSC-Regular
          font-weight 400
          font-size 11px
          line-height 12px
          color #ff5900
          margin-bottom 2px
        .buy-btn
          height 30px
          display flex
          align-items center
          white-space nowrap
          padding 0px 16px
          font-size 14px
          line-height 1
          color #fff
          background #338FFF
          border-radius 7px
          font-family PingFangSC-Medium
          font-weight 500
    .login-content-container
      width 100%
      padding 0 16px
      padding-bottom 16px
      box-sizing border-box
      background #fff
      border-radius 8px
  .protocol
    font-size 14px
    display inline
    line-height 17px
    font-weight 400
    font-family PingFangSC-Regular
    &.text
      color #666
    &.url
      color #338FFF
  .es-rm-agree-box
    display flex
    justify-content space-between
    .es-login-agree-left
      display flex
      align-items center
      flex 1
      .es-rm-agreement
        >>> .es-rm-checkbox
          color #666
        >>> .es-checkbox--checked
          border none
    .es-rm-navigator
      display flex
      align-items center
      font-size 12px !important
      line-height 1
      color #000
      text-decoration none
      letter-spacing 0
      &.highlight
        color #338FFF
      &.es-line
        display inline
  .es-rm-checkbox
    font-size 12px
    color $train-color-999
    margin-left -5px
  .buttonStyle
    box-sizing border-box
    height 48px
    font-size 16px
    border-radius 8px
    font-family PingFangSC-Medium
    font-weight normal
    line-height 1
    letter-spacing 0
    display flex
    align-items center
    justify-content center
    &.login
      color #fff
      background #338FFF
      margin-top 12px
  .register
    box-sizing border-box
    color #338FFF
    font-size 12px
    line-height 14px
    margin-top 16px
    font-family PingFangSC-Regular
    font-weight 400
    text-align center
  .change-user
    box-sizing border-box
    margin-top 16px
    color #3D3D3D
    font-size 12px
    line-height 14px
    font-family PingFangSC-Medium
    font-weight 500
    text-align center
  .backgroundStyle
    padding 19px 24px 24px
    background-color #FFFFFF
    .banner
      margin-bottom 37px
      &.quick
        margin-bottom 53px
    .history-account
      margin-top 32px
  .inputStyle
    font-size 16px
    outline none
    flex 1
    height 20px
    font-family PingFangSC-Medium
    font-weight normal
    line-height 1
    letter-spacing 0px
    color #000000
    -webkit-tap-highlight-color transparent
    &::placeholder
      font-family PingFangSC-Regular
      font-size 16px
      font-weight normal
      line-height 1
      letter-spacing 0px
      color #999999
  .quick-login-account
    font-family PingFangSC-Medium
    font-weight 500
    font-size 24px
    line-height 24px
    color #000
    margin 30px 0
    text-align center
  .es-login-input
    height 56px
    display flex
    align-items center
    justify-content space-between
    border-bottom 1px #EEEEEE solid
    position relative
    .icon-eye-close
      flex none
      margin-left 8px
      @extend .expand-click
      width 20px
      height 20px
      .es-eye
        width 16px
        height 16px
  .form-block
    height 24px
  .es-zdy-icon
    width 16px
    height 16px
  .quick-entrance
    padding-bottom 57px
    box-sizing border-box
    width 100%
    display flex
    align-items center
    justify-content center
    .entrance-item
      font-family PingFangSC-Regular
      font-size 12px
      font-weight normal
      height 24px
      letter-spacing 0px
      color #000000
      margin 0 30px
      position relative
      &+.entrance-item
        margin-left 31px
        &::before
          content ''
          position absolute
          left -30px
          top 3px
          width 1px
          height 10px
          background-color #999
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "mf9ffda7a"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findexf9ffda7a%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findexf9ffda7a%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["mf9ffda7a"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/indexf9ffda7a/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'es-riskmanagement':getComponent(require("../../pages/login12306/components/rm/risk-management.mpx?isComponent&outputPath=components%2Frisk-management0659070a%2Findex")),'es-checkbox-group':getComponent(require("../../es-mpx-ui/lib/checkbox-group/index.mpx?isComponent&outputPath=components%2Findex5f7ef460%2Findex")),'es-checkbox':getComponent(require("../../es-mpx-ui/lib/checkbox/index.mpx?isComponent&outputPath=components%2Findex8e1a7e44%2Findex")),'spring-icon':getComponent(require("../../../node_modules/@didi/spring-icon/index/index.mpx?isComponent&outputPath=components%2Findex4d1d0d54%2Findex")),'controllable-drawer-bottom':getComponent(require("../controllable-drawer-buttom.mpx?isComponent&outputPath=components%2Fcontrollable-drawer-buttomcb57d2b4%2Findex")),'mpx-input':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-input.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
